import type { FaireProductEntity } from "../../entity_types/product";

export const p_ntybpdcu2j: FaireProductEntity = {
  token: "p_ntybpdcu2j",
  type: "product",
  name: "Taper Candle Collection, Set of 6 | FIRE",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/7ed122544d6b6fc785fbcc7027966dfb33af971dde27944966b724f499f0657b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8cd48f6ceaecf322011879aa0007f50a9d63e5395aae6ede6e8935da61c933b6.jpeg",
    "https://cdn.faire.com/fastly/548f8e68bba9623a55676bfd03ee7164efc22b48472b2489c51596098bde0c05.jpeg",
    "https://cdn.faire.com/fastly/9e9ef330c724ff08d673047bffd35e88936313f940c99e77ecdbfebed2a39c05.jpeg",
  ],
  priceDollars: 19,
  description:
    "FIRE | ARIES, LEO, SAGITTARIUS\n\nBotanica taper candles are dipped over 20 times by hand, creating the ideal taper–dripless and smokeless–perfect for dinner parties and creating warm, homey ambiance. Our Taper Candles are slightly textured for a handmade finish, and beautifully dyed in an array of shades reflecting the Elemental Collection. Each candle is 10″, 7/8″ diameter, and burns for approximately 8 hours.\n\nUnscented\nIncludes 6 taper candles\n\n• BENEFITTING: THE ART THERAPY PROJECT\n• 6-QTY. 10″ TAPER CANDLES | 8 HOUR BURN TIME\n• GIFT BOX",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:52.084Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
